module.exports = __webpack_public_path__ + "img/photo-restaurant-partner.1dd39fcd.jpg";